import React from 'react';
import Avatar from '@mui/material/Avatar';
import { FONT_FAMILY } from 'common/sharedFunctions';

const ImageCarousel = ({ item }) => {
  // Array of images, ensuring we only use available images
  const images = [
    item?.car_front_image,
    item?.car_back_image,
    item?.car_image,
  ].filter(Boolean); // Filter out any undefined or null images

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true, // Optional: adjust height based on the current slide
    arrows: true, // Show next and previous arrows
  };

  return (
    <div style={{ width: '100%' }}>
      {images.length > 0 ? (
        <div style={{display: 'flex', gap: 6}}>
          {images.map((image, index) => (
            <div key={index} style={{ display: 'flex', justifyContent: 'center' }}>
              <Avatar
                alt={`Image ${index + 1}`}
                src={image}
                sx={{
                  width: '100%', // Set to 100% width
                  height: 'auto', // Maintain aspect ratio
                  borderRadius: "19px",
                }}
                variant="square"
              />
            </div>
          ))}
          </div>
      ) : (
        <Avatar
          sx={{ width: 250, height: 140, fontFamily: FONT_FAMILY }}
          variant="square"
        >
          {'No images available'}
        </Avatar>
      )}
    </div>
  );
};

export default ImageCarousel;
